export default __webpack_public_path__ + "static/media/Biologia.c1d7b8e3.png";